module.exports = __webpack_public_path__ + "static/img/img-zixun.9a514f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-zixun.png
// module id = /fyZ
// module chunks = 0